import Meta from "$/components/Meta";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Chip, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useBlogPost } from "../hooks/useBlogPost";

export default function BlogPostPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { post, isLoading, error } = useBlogPost(id);

  if (isLoading) {
    return (
      <Container>
        <Typography>Loading post...</Typography>
      </Container>
    );
  }

  if (error || !post) {
    return (
      <Container>
        <Typography color="error">Error loading blog post</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Meta
        title={post.title}
        description={post.excerpt}
        keywords={post.tags.join(", ").replace(/-/g, " ") + ", tattoo blog"}
        image={post.image}
      />
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/blog")}
        sx={{ mb: 4 }}
      >
        Back to Blog
      </Button>

      <Typography variant="h2" component="h1" gutterBottom>
        {post.title}
      </Typography>

      {/* <Box sx={{ mb: 4 }}>
        <img
          src={post.image}
          alt={post.title}
          width={800}
          height={400}
          style={{ objectFit: "cover", maxWidth: "100%" }}
        />
      </Box> */}

      <Box sx={{ mb: 4 }}>
        <Typography color="text.secondary" gutterBottom>
          {new Date(post.date).toLocaleDateString()} • {post.author}
        </Typography>

        {post.tags && (
          <Box sx={{ mt: 2 }}>
            {post.tags.map((tag) => (
              <Chip key={tag} label={tag} size="small" sx={{ mr: 1, mb: 1 }} />
            ))}
          </Box>
        )}
      </Box>

      <Typography
        variant="body1"
        sx={{ whiteSpace: "pre-wrap", fontSize: 20, lineHeight: "34px" }}
      >
        {post.content}
      </Typography>
    </Container>
  );
}
